import * as Yup from 'yup'

import { emailValidation } from 'utils'

export const validationSchema = Yup.object({
  email: emailValidation,
})
